// extracted by mini-css-extract-plugin
module.exports = {"root":"player_root__1wZHa"};